import { customerGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as z from "zod/v4";

export const getCustomerGroups = {
  name: "getCustomerGroups" as const,
  input: z.object({}),
  output: z.array(customerGroupSchema),
};
